import styled from "styled-components"

export const ErrorPageContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: white;
  text-align: center;
`
